<template>
  <div>
    <div class="search-flex">
      <!-- 搜索框 -->
      <div>
        <el-input
          class="search_input"
          clearable
          placeholder="商品编号"
          size="small"
          v-model="searchParams.goodsCode"
        ></el-input>
        <el-input
          class="search_input"
          clearable
          placeholder="商品名称"
          size="small"
          v-model="searchParams.goodsName"
        ></el-input>
        <el-select
          class="search_input"
          clearable
          placeholder="销售端类型"
          size="small"
          v-model="searchParams.clientTypes"
          multiple
          collapse-tags
        >
          <el-option
            v-for="item in clientTypes.value"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <!-- 商品状态 -->
        <el-select
          class="search_input"
          clearable
          placeholder="商品状态"
          size="small"
          v-model="searchParams.state"
        >
          <el-option label="生效" value="1"> </el-option>
          <el-option label="失效" value="0"> </el-option>
        </el-select>
        <!-- 审核状态 -->
        <el-select
          v-if="currentTab.value === 'local'"
          class="search_input"
          clearable
          placeholder="审核状态"
          size="small"
          v-model="searchParams.reviewStatus"
        >
          <el-option label="草稿" value="1"> </el-option>
          <el-option label="待审核" value="2"> </el-option>
          <el-option label="审核通过" value="3"> </el-option>
          <el-option label="审核不通过" value="4"> </el-option>
        </el-select>
      </div>
      <div>
        <!-- 搜索按钮 -->
        <el-button
          v-auth="'MEMBER_UNITE_SEARCH'"
          type="primary"
          size="small"
          @click="search"
          >搜索</el-button
        >
        <!-- 新增按钮 -->
        <el-button
          v-auth="'MEMBER_UNITE_ADD'"
          v-if="currentTab.value === 'local'"
          type="primary"
          size="small"
          @click="add"
          >新增</el-button
        >
      </div>
    </div>
    <AddDialog ref="addDialog"></AddDialog>
  </div>
</template>

<script>
import AddDialog from "./Add.vue";
import Message from "@/components/Message";
export default {
  inject: ["searchParams", "getList", "currentTab", "clientTypes"],
  components: {
    AddDialog,
  },
  name: "WebSaaSSearch",
  data() {
    return {};
  },

  methods: {
    /** 点击搜索的方法 */
    search() {
      console.log("search", this.searchParams);
      /** 搜索时把当前页置为第一页 */
      this.searchParams.current = 1;
      this.getList();
      Message.success("搜索成功");
    },
    /** 点击新增的方法 */
    add() {
      this.$refs.addDialog.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 160px !important;
  margin: 10px 20px 0 0;
}
::v-deep .el-select__tags {
  flex-wrap: nowrap !important;
}
</style>